__turbopack_context__.v({
  "container": "XlpC8q_container",
  "content": "XlpC8q_content",
});
